import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { OrgBankAccountListModule } from '../../shared/org-bank-account-list/org-bank-account-list.module';
import { OrganizationDashboardComponent } from './organization-dashboard.component';
import { DashPaymentsModule } from './dash-payments/dash-payments.module';
import { DashExpenseGraphModule } from './dash-expense-graph/dash-expense-graph.module';
import { ScrollService } from '../../../../services/scroll.service';
import { DashWidgetsModule } from './dash-widgets/dash-widgets.module';
import { CollectionProgressGraphModule } from '../../shared/collection-progress-graph/collection-progress-graph.module';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        RouterModule.forChild([
            {
                path: '',
                component: OrganizationDashboardComponent,
            },
        ]),
        DashPaymentsModule,
        CollectionProgressGraphModule,
        DashExpenseGraphModule,
        OrgBankAccountListModule,
        DashWidgetsModule,
    ],
    declarations: [
        OrganizationDashboardComponent,
    ],
    providers: [
        ScrollService,
    ],
})
export class OrganizationDashboardModule
{
}
